import { render, staticRenderFns } from "./Bonuses.vue?vue&type=template&id=6a7d6d2a"
import script from "./Bonuses.vue?vue&type=script&lang=js"
export * from "./Bonuses.vue?vue&type=script&lang=js"
import style0 from "./Bonuses.vue?vue&type=style&index=0&id=6a7d6d2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports